var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "allergy-kpi-report" } },
    [
      _c("Navigation"),
      _vm._v(" "),
      _c("Filters"),
      _vm._v(" "),
      _vm.report ? _c("ContentBody") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }